// import React from "react";

// export default function BlogCareersAfter10th({ onBack }) {
//   return (
//     <article className="min-h-screen bg-gradient-to-b from-yellow-50 via-white to-blue-50 py-20 px-6">
//       <div className="max-w-3xl mx-auto">
//         <button
//           onClick={onBack}
//           className="mb-6 text-indigo-600 hover:underline font-semibold text-sm"
//         >
//           ← Back to Blog
//         </button>

//         <header className="mb-10">
//           <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
//             Best Career Options After 10th Standard — A Complete Guide (2026)
//           </h1>
//           <p className="mt-4 text-gray-500 text-sm">
//             Published by <span className="font-semibold text-indigo-600">Systematic Career Planner</span> · Updated May 2026 · 10 min read
//           </p>
//         </header>

//         <img
//           src="https://images.unsplash.com/photo-1523050854058-8df90110c7f1?w=800&q=80"
//           alt="Students planning career after 10th"
//           className="w-full rounded-2xl shadow-lg mb-10"
//         />

//         <section className="prose prose-lg max-w-none text-gray-700 space-y-8">
//           <h2 className="text-2xl font-bold text-gray-800">Why 10th Standard Is a Critical Decision Point</h2>
//           <p>
//             The transition after 10th standard is one of the most important milestones in a student's academic journey.
//             Choosing the right stream — Science, Commerce, or Arts — sets the direction for your entire career.
//             A wrong decision at this stage can lead to years of frustration and wasted potential. This is where
//             <strong> Systematic Career Planning (SCP)</strong> helps — we treat career decisions like investments,
//             ensuring every step counts.
//           </p>

//           <h2 className="text-2xl font-bold text-gray-800">Stream Options After 10th</h2>

//           <h3 className="text-xl font-semibold text-indigo-700">1. Science Stream (PCM / PCB)</h3>
//           <p>
//             <strong>PCM (Physics, Chemistry, Mathematics)</strong> opens doors to Engineering, IT, Architecture, Data Science,
//             Merchant Navy, and Defence services. <strong>PCB (Physics, Chemistry, Biology)</strong> leads to Medicine (MBBS/BDS),
//             Pharmacy, Biotechnology, Nursing, and Allied Health Sciences.
//           </p>
//           <ul className="list-disc list-inside space-y-1">
//             <li>Engineering (B.Tech/B.E.) via JEE Main &amp; Advanced</li>
//             <li>Medical (MBBS/BDS) via NEET</li>
//             <li>Architecture (B.Arch)</li>
//             <li>Data Science &amp; AI careers</li>
//             <li>Pilot training &amp; Aviation</li>
//           </ul>

//           <h3 className="text-xl font-semibold text-indigo-700">2. Commerce Stream</h3>
//           <p>
//             Commerce is ideal for students interested in finance, business, and management. Top career paths include
//             Chartered Accountancy (CA), Company Secretary (CS), Cost &amp; Management Accounting (CMA), BBA, B.Com,
//             and Banking.
//           </p>
//           <ul className="list-disc list-inside space-y-1">
//             <li>Chartered Accountancy (CA) — one of the highest-paying careers</li>
//             <li>Company Secretary (CS)</li>
//             <li>BBA + MBA path</li>
//             <li>Banking &amp; Insurance (IBPS, SBI)</li>
//             <li>Stock Market &amp; Financial Planning</li>
//           </ul>

//           <h3 className="text-xl font-semibold text-indigo-700">3. Arts / Humanities Stream</h3>
//           <p>
//             Arts is no longer a "fallback" option. It opens paths to Law, Mass Communication, Psychology,
//             Civil Services (IAS/IPS), Fashion Design, Fine Arts, and Social Work.
//           </p>
//           <ul className="list-disc list-inside space-y-1">
//             <li>Law (BA LLB — 5-year integrated)</li>
//             <li>Civil Services (UPSC IAS/IPS)</li>
//             <li>Journalism &amp; Mass Communication</li>
//             <li>Psychology &amp; Counseling</li>
//             <li>Fashion &amp; Interior Design</li>
//           </ul>

//           <h3 className="text-xl font-semibold text-indigo-700">4. Vocational &amp; Diploma Courses</h3>
//           <p>
//             For students who want to start earning early or develop hands-on skills: ITI courses,
//             Polytechnic Diplomas, Digital Marketing, Web Development, and Animation.
//           </p>

//           <h2 className="text-2xl font-bold text-gray-800">How to Choose the Right Stream</h2>
//           <div className="bg-indigo-50 rounded-xl p-6 border-l-4 border-indigo-500">
//             <p className="font-semibold text-indigo-800 mb-2">The SCP Approach — Don't Leave Your Career to Chance</p>
//             <ol className="list-decimal list-inside space-y-2">
//               <li><strong>Self-assessment</strong> — Understand your interests, aptitude, and strengths</li>
//               <li><strong>Explore options</strong> — Research all available career paths, not just popular ones</li>
//               <li><strong>Talk to mentors</strong> — Get guidance from industry professionals who've walked the path</li>
//               <li><strong>Consider future scope</strong> — Look at industry trends, salary potential, and growth opportunities</li>
//               <li><strong>Plan systematically</strong> — Like a SIP for your career — invest time now for long-term returns</li>
//             </ol>
//           </div>

//           <h2 className="text-2xl font-bold text-gray-800">Common Mistakes to Avoid</h2>
//           <ul className="list-disc list-inside space-y-2">
//             <li>Choosing a stream because of peer pressure or parental expectations</li>
//             <li>Ignoring your natural interests and aptitude</li>
//             <li>Not researching career options beyond Engineering &amp; Medicine</li>
//             <li>Delaying the decision until the last minute</li>
//           </ul>

//           <div className="bg-pink-50 rounded-xl p-6 mt-8 text-center">
//             <p className="text-lg font-bold text-gray-800 mb-2">Need Personalized Career Guidance?</p>
//             <p className="text-gray-600 mb-4">
//               Book a one-on-one consultation with our career experts. Right decisions at the right time!
//             </p>
//             <div className="flex flex-wrap justify-center gap-4">
//               <a href="#contact" className="px-6 py-3 rounded-full bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition">
//                 📅 Book Free Consultation
//               </a>
//               <a
//                 href="https://wa.me/919920405421?text=Hi%2C%20I%20need%20career%20guidance%20after%2010th"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="px-6 py-3 rounded-full bg-green-500 text-white font-semibold hover:bg-green-600 transition"
//               >
//                 💬 WhatsApp Us
//               </a>
//             </div>
//           </div>
//         </section>
//       </div>
//     </article>
//   );
// }
import React from "react";

export default function BlogCareersAfter10th({ onBack, onConsultationClick }) {
  return (
    <article className="min-h-screen bg-gradient-to-b from-yellow-50 via-white to-blue-50 py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={onBack}
          className="mb-6 text-indigo-600 hover:underline font-semibold text-sm"
        >
          ← Back to Blog
        </button>

        <header className="mb-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Best Career Options After 10th Standard — A Complete Guide (2026)
          </h1>
          <p className="mt-4 text-gray-500 text-sm">
            Published by <span className="font-semibold text-indigo-600">Systematic Career Planner</span> · Updated May 2026 · 10 min read
          </p>
        </header>

        <img
          src="https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&auto=format&fit=crop&q=80"
          alt="Students planning career after 10th"
          className="w-full rounded-2xl shadow-lg mb-10"
          onError={(e) => { e.target.style.display = 'none'; }}
        />

        <section className="prose prose-lg max-w-none text-gray-700 space-y-8">
          <h2 className="text-2xl font-bold text-gray-800">Why 10th Standard Is a Critical Decision Point</h2>
          <p>
            The transition after 10th standard is one of the most important milestones in a student's academic journey.
            Choosing the right stream — Science, Commerce, or Arts — sets the direction for your entire career.
            A wrong decision at this stage can lead to years of frustration and wasted potential. This is where
            <strong> Systematic Career Planning (SCP)</strong> helps — we treat career decisions like investments,
            ensuring every step counts.
          </p>

          <h2 className="text-2xl font-bold text-gray-800">Stream Options After 10th</h2>

          <h3 className="text-xl font-semibold text-indigo-700">1. Science Stream (PCM / PCB)</h3>
          <p>
            <strong>PCM (Physics, Chemistry, Mathematics)</strong> opens doors to Engineering, IT, Architecture, Data Science,
            Merchant Navy, and Defence services. <strong>PCB (Physics, Chemistry, Biology)</strong> leads to Medicine (MBBS/BDS),
            Pharmacy, Biotechnology, Nursing, and Allied Health Sciences.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Engineering (B.Tech/B.E.) via JEE Main &amp; Advanced</li>
            <li>Medical (MBBS/BDS) via NEET</li>
            <li>Architecture (B.Arch)</li>
            <li>Data Science &amp; AI careers</li>
            <li>Pilot training &amp; Aviation</li>
          </ul>

          <h3 className="text-xl font-semibold text-indigo-700">2. Commerce Stream</h3>
          <p>
            Commerce is ideal for students interested in finance, business, and management. Top career paths include
            Chartered Accountancy (CA), Company Secretary (CS), Cost &amp; Management Accounting (CMA), BBA, B.Com,
            and Banking.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Chartered Accountancy (CA) — one of the highest-paying careers</li>
            <li>Company Secretary (CS)</li>
            <li>BBA + MBA path</li>
            <li>Banking &amp; Insurance (IBPS, SBI)</li>
            <li>Stock Market &amp; Financial Planning</li>
          </ul>

          <h3 className="text-xl font-semibold text-indigo-700">3. Arts / Humanities Stream</h3>
          <p>
            Arts is no longer a "fallback" option. It opens paths to Law, Mass Communication, Psychology,
            Civil Services (IAS/IPS), Fashion Design, Fine Arts, and Social Work.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Law (BA LLB — 5-year integrated)</li>
            <li>Civil Services (UPSC IAS/IPS)</li>
            <li>Journalism &amp; Mass Communication</li>
            <li>Psychology &amp; Counseling</li>
            <li>Fashion &amp; Interior Design</li>
          </ul>

          <h3 className="text-xl font-semibold text-indigo-700">4. Vocational &amp; Diploma Courses</h3>
          <p>
            For students who want to start earning early or develop hands-on skills: ITI courses,
            Polytechnic Diplomas, Digital Marketing, Web Development, and Animation.
          </p>

          <h2 className="text-2xl font-bold text-gray-800">How to Choose the Right Stream</h2>
          <div className="bg-indigo-50 rounded-xl p-6 border-l-4 border-indigo-500">
            <p className="font-semibold text-indigo-800 mb-2">The SCP Approach — Don't Leave Your Career to Chance</p>
            <ol className="list-decimal list-inside space-y-2">
              <li><strong>Self-assessment</strong> — Understand your interests, aptitude, and strengths</li>
              <li><strong>Explore options</strong> — Research all available career paths, not just popular ones</li>
              <li><strong>Talk to mentors</strong> — Get guidance from industry professionals who've walked the path</li>
              <li><strong>Consider future scope</strong> — Look at industry trends, salary potential, and growth opportunities</li>
              <li><strong>Plan systematically</strong> — Like a SIP for your career — invest time now for long-term returns</li>
            </ol>
          </div>

          <h2 className="text-2xl font-bold text-gray-800">Common Mistakes to Avoid</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Choosing a stream because of peer pressure or parental expectations</li>
            <li>Ignoring your natural interests and aptitude</li>
            <li>Not researching career options beyond Engineering &amp; Medicine</li>
            <li>Delaying the decision until the last minute</li>
          </ul>

          <div className="bg-pink-50 rounded-xl p-6 mt-8 text-center">
            <p className="text-lg font-bold text-gray-800 mb-2">Need Personalized Career Guidance?</p>
            <p className="text-gray-600 mb-4">
              Book a one-on-one consultation with our career experts. Right decisions at the right time!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button onClick={onConsultationClick} className="px-6 py-3 rounded-full bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition">
                📅 Book Free Consultation
              </button>
              <a
                href="https://wa.me/919920405421?text=Hi%2C%20I%20need%20career%20guidance%20after%2010th"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 rounded-full bg-green-500 text-white font-semibold hover:bg-green-600 transition"
              >
                💬 WhatsApp Us
              </a>
            </div>
          </div>
        </section>
      </div>
    </article>
  );
}
